import { GET } from 'shared/api/GET'
import { consoleError } from 'shared/helpers/consoleError'
import { useLoadingStore } from 'shared/store/toasterSlice'
import { useBranchStore } from '../../../shared/store/branchesSlice'

export const checkPaymentHealth = async () => {
  const { startLoading, finishWithSuccess, finishWithError,  } = useLoadingStore.getState()
  const branchId = useBranchStore.getState().branchId
  try {
    startLoading()
    const res = await GET.paymentStatus(branchId || 0)
    if (res.status === 1) {
      finishWithSuccess()
    } else {
      throw new Error(res.message)
    }
  } catch (error) {
    consoleError(error)
    finishWithError()
  }
}
